import React from 'react';

const TestimonialCard = ({ text, author, position, company }) => {
  return (
    <div className="testimonial-card">
      <div className="testimonial-text">
        <p>{text}</p>
      </div>
      <div className="testimonial-author">
        <div className="author-avatar">
          {author.split(' ').map(n => n[0]).join('')}
        </div>
        <div className="author-info">
          <h4>{author}</h4>
          <p>{position} at {company}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;